// extracted by mini-css-extract-plugin
export default {"navDropdown":"ukNsN6SQ"};